// A DOM icon: one canvas the art/domIcons provider draws into (IMPLEMENTATION §2.9 "domIcons renders
// directly from the generators"; M6 decision 7: the caller owns the canvas, the provider's LRU fills it).
// `icon` = a board item / building (the same frame the board shows), `frame` = any catalog frame by id
// (UI icons `ui.coin`, Sarge poses). Redraws only when the key, size or the device pixel ratio changes.
import { useEffect, useRef } from 'preact/hooks';
import type { IconKey } from '../../fx/icons.ts';
import { shellCtx } from '../ctx.ts';

export interface IconProps {
  icon?: IconKey | null;
  frame?: string | null;
  px: number;
  class?: string;
  /** Silhouette (a locked card): drawn at 30%, desaturated. */
  dim?: boolean;
}

function keyOf(i: IconKey): string {
  return i.k === 'item' ? `i:${i.fam}:${i.tier}` : `b:${i.type}:${i.ore ?? ''}:${i.level}`;
}

export function Icon({ icon = null, frame = null, px, class: cls, dim = false }: IconProps) {
  const ref = useRef<HTMLCanvasElement>(null);
  const dpr = typeof window === 'undefined' ? 1 : window.devicePixelRatio;
  const k = icon ? keyOf(icon) : (frame ?? '');
  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    const icons = shellCtx().icons;
    if (icon) icons.draw(icon, c, px);
    else if (frame) icons.drawFrame(frame, c, px);
  }, [k, px, dpr]);
  return (
    <canvas
      ref={ref}
      class={`gm-icon ${cls ?? ''} ${dim ? 'dim' : ''}`}
      style={{ width: `${px}px`, height: `${px}px` }}
    />
  );
}
